define('services/logger',['durandal/system', 'toastr', 'services/appsecurity'],
    function (system, toastr, appsecurity) {
        var logger = {
            appsecurity: appsecurity,
            log: log,
            logError: logError,
            logSuccess: logSuccess,
            logWarning: logWarning,
            logMessage: logMessage,
            logServer: logServer
        };

        return logger;

        function log(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'info');
        }

        function logError(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'error');
        }
        function logSuccess(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'success');
        }
        function logWarning(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'warning');
        }
        function logServer(message, data, source, showToast) {
            logIt(message, data, source, showToast, 'server');
        }

        function logIt(message, data, source, showToast, toastType) {
            source = source ? '[' + source + '] ' : '';
            if (data) {
                system.log(source, message, data);
            } else {
                system.log(source, message);
            }
            if (showToast) {
                if (toastType === 'error') {
                    toastr.error(message, 'Error');
                }
                else if (toastType === 'success') {
                    toastr.success(message, 'Success');
                }
                else if (toastType === 'warning') {
                    toastr.warning(message, 'Warning');
                }
                else if (toastType === 'server') {
                    toastr.server(message, 'Server Error');
                }
                else {
                    toastr.info(message, 'Information');

                }

            }

        }

        function logMessage(message) {
            //var csrfToken = $("input[name='__RequestVerificationToken']").val();
            //var headers = appsecurity.getSecurityHeaders();
            //headers.__RequestVerificationToken = csrfToken;
            //var msg = encodeURI(message);
            //var options = {
            //    url: "/api/Log/LoggingMessage?sErrMsg=" + msg,
            //    type: "POST",
            //    headers: headers
            //};

            ////Make the ajax Call
            //$.ajax(options).success(ajaxSuccess)
            //.fail(ajaxFail);

            //function ajaxSuccess(result, status) {




            //}

            //function ajaxFail(status, errormessage) {

            //}
        }
    });
